export default {
  'page-title': 'Creative Rücksendung - Creative Labs (Germany)',
  'page-desc': 'Eine Anfrage an den Creative Kundenservice stellen bezüglich einer Rücksendung. ',
  'mode-of-contact': 'Kontaktart',
  'your-details': 'Ihre Daten',
  'rma-request': 'RMA-Anfrage',
  'first-name': 'Vorname',
  'last-name': 'Nachname',
  'enter-first-name': 'Bitte geben Sie Ihren Vornamen ein',
  'enter-last-name': 'Bitte geben Sie ihren Nachnamen ein',
  'email-address': 'E-Mail-Addresse',
  'enter-email': 'Geben Sie bitte Ihre Email-Adresse ein',
  'enter-valid-email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'enter-pid': 'Enter your personal ID',
  'super-x-fi': 'Super X-Fi',
  'products': 'Produkte',
  'sale': 'Sale',
  'help': 'Hilfe',
  'sign-in': 'Anmelden',
  'account': 'Account',
  'loading-page': 'LADEN',
  'orders': 'Bestellungen',
  'membership-program': 'Mitgliedschaftsprogramm',
  'account-profile': 'Account-Profil',
  'contact-us': 'Kontakt ',
  'sign-out': 'Abmelden',
  'recent-orders': 'letzte Bestellungen',
  'view-all-orders': 'Alle Bestellungen anzeigen',
  'email_registered': {
    'text1': 'E-Mail wurde bereits registriert ',
    'link': 'Anmelden',
    'text2': ' um Ihre Bestellhistorie abzurufen'
  },
  'country-region': 'Land / Region',
  'select-country': 'Bitte Land auswählen',
  'preferred-language': 'Bevorzugte Sprache der Antwort',
  'select-language': 'Bitte wählen Sie die Sprache',
  'next': 'Weiter',
  'encountered-error': 'Wir haben einen Fehler festgestellt. Bitte versuchen Sie es erneut',
  'your-enquiry': 'Ihre Anfrage',
  'nature-enquiry': 'Art der Anfrage',
  'order-number': 'Bestellnummer',
  'order-id': 'Bestell-ID',
  'for-amazon-order': 'Für Bestellungen über Amazon',
  'enter-order-number': 'Bitte geben Sie Ihre Bestellnummer ein',
  'rma-number': 'RMA-Nummer',
  'enter-rma-number': 'Bitte geben Sie Ihre RMA-Nummer ein',
  'purchase_creative_com': {
    'text': 'Wenn Ihr defektes Produkt bei Creative.com gekauft wurde ',
    'link': 'Fordern Sie hier einen Ersatz an'
  },
  'not-purchase-creative-com': '<p>Wenn Sie nicht direkt bei Creative.com gekauft haben, wenden Sie sich für Rücksendeanfragen bitte direkt an Ihren Händler</p><p><a href="https://de.creative.com/help/garantie-und-r-ckgabe" target="_blank">Klicken Sie hier, um Informationen zu Garantie und Rückgabe zu erhalten.</a></p>',
  'not-purchase-creative-com-retailer-replacement': 'Wenn Sie nicht direkt bei Creative.com gekauft haben, wenden Sie sich bitte direkt an Ihren Händler, um Ersatzanfragen zu stellen.',
  'not_purchase_creative_com_2': {
    'text': 'Wenn Ihr defektes Produkt nicht direkt von Creative.com gekauft wurde ',
    'link': 'Fordern Sie hier einen Ersatz an'
  },
  'order-not-found': 'Die von Ihnen eingegebene Bestellnummer konnte nicht in unserem System gefunden werden.Bitte geben Sie eine gültige Bestellnummer ein.',
  'rma-not-found': 'Die von Ihnen eingegebene RMA - Nummer konnte nicht in unserem System gefunden werden.Bitte geben Sie eine gültige RMA - Nummer ein.',
  'previous-order': 'Vorherige Bestellung',
  'next-order': 'Nächste Bestellung',
  'add-your-product': 'Fügen Sie Ihr Produkt hinzu',
  'search-by-name': 'Suche über Produktnamen',
  'select-product': 'Bitte Produkt auswählen.',
  'upload-proof-update-date': {
    'text1': 'Bitte stellen Sie Ihren Kaufnachweis und das Kaufdatum zur Verfügung. <br/>Wenn Sie keinen Kaufbeleg haben,  ',
    'link': 'kontaktieren',
    'text2': ' Sie uns bitte hier.'
  },
  'return-product': 'Produkt zurücksenden',
  'return-products': 'Produkt(e) zurücksenden',
  'replace-defective-product': 'Defektes Produkt ersetzen',
  'check-rma-status': 'Überprüfen Sie Ihren RMA-Status',
  'service-request': 'Serviceanforderung(en) verfügbar',
  'select-one-service': 'Bitte wählen Sie eine Serviceanfrage aus. Wenn Sie mehr als eine Serviceanfrage für dieselbe Bestellung haben, stellen Sie bitte für jede Ausgabe eine andere Serviceanfrage.',
  'select-one-servcie-2': 'Bitte wählen Sie eine Serviceanfrage aus.',
  'refund-products': 'Produkt(e) zurückerstatten',
  'qualifies-refund': 'Nur {} hat Anspruch auf eine Rückerstattung im Rahmen der Zufriedenheitsgarantie. <> Bitte bearbeiten Sie Ihre Produkte, bevor Sie fortfahren.',
  'replace-products': 'Defekte(s) Produkt(e) austauschen',
  'qualifies-replace': 'Nur {} kann ausgetauscht werden. <> Bitte bearbeiten Sie Ihre Produkte, bevor Sie fortfahren.',
  'contact-us-assistance': 'Kontaktieren Sie uns für Unterstützung',
  'return-information': 'Informationen zur Rückgabe',
  'replacement-information': 'Informationen zum Austausch',
  'fill-in-all': 'Bitte füllen Sie alle Felder in diesem Abschnitt aus.',
  'message': 'Nachricht',
  'enter-message': 'Bitte geben Sie Ihre Nachricht ein.',
  'submit': 'Absenden',
  'submission-successful': 'Ihr Beitrag wurde eingereicht.',
  'contact-us-thank-you': 'Wir werden uns innerhalb 2 Werktagen bei Ihnen melden..',
  'back-to-home': 'Zurück zur Startseite',
  'confirmation': 'Bestätigung',
  'rma-confirmation': 'RMA-Bestätigung',
  'refresh-page': 'Aktualisieren',
  'loading': 'Wird geladen…...',
  'select': 'Wählen Sie die Adresse',
  'selected': 'Ausgewählt',
  'update': 'Adresse bearbeiten',
  'address': 'ADRESSE',
  'new-address': 'Neue Adresse',
  'edit': 'Bearbeiten',
  'update-address': 'Adresse aktualisieren',
  'cancel': 'Abbrechen',
  'back': 'Zurück',
  'select-your-products': 'Wählen Sie Ihre Produkte aus',
  'serial-number': 'Seriennummer',
  'returns-eligibility': 'Berechtigung zur Rückgabe',
  'warranty': 'Garantie',
  'proof-purchase': 'Kaufnachweis',
  'purchase-date': 'Kaufdatum',
  'select-date': 'Kaufdatum',
  'how-find-serial-num': 'So finden Sie Ihre Seriennummer?',
  'yes': 'Ja',
  'no': 'Nein',
  'choose-file': 'Datei wählen',
  'upload-supporting-file': 'Bild hochladen',
  'remove': 'Entfernen',
  'warranty-days-left': '{warrantyDaysRemain} Tage übrig',
  'out-warranty': 'Garantie abgelaufen',
  'enter-serial': 'Geben Sie Seriennummer ',
  'enter-serial-number': 'Bitte geben Sie eine gültige Seriennummer ein.',
  'serial-not-valid': 'Bitte geben Sie eine gültige Seriennummer ein.',
  'serial-num-submitted': 'Seriennummer bereits genutzt, bitte geben Sie eine andere ein.',
  'file-formats-allowed': 'Zulässige Dateiformate: JPG, PNG, ZIP. Maximale Dateigröße: 4 MB.',
  'thank-you-rma-submit': 'Vielen Dank für das Einreichen Ihrer RMA.',
  'provide-rma-number': 'Bitte geben Sie Ihre RMA-Nummer an unser Kundendienstteam weiter, wenn Sie uns bezüglich ... kontaktieren..',
  'retrieve_rma_status': {
    'text': 'Sie können auch Ihren RMA-Status abrufen oder Änderungen an Ihrer RMA vornehmen, indem Sie sich für einen ... registrieren ',
    'link': 'Creative Store-Account'
  },
  'product-details': 'Produktdetails',
  'product': 'Produkt',
  'rma-details': 'RMA-Details',
  'service-request2': 'Service-Anfrage',
  'refund': 'Rückerstattung',
  'replacement': 'Ersatz',
  'rma-status': 'RMA-Status',
  'expires-date': 'Läuft ab {date}',
  'refund-estimated-cost': 'Hinweis: Der Rückerstattungsbetrag ist derzeit eine Schätzung und kann weiteren Änderungen unterliegen.  ',
  'service-fee': 'Servicegebühr',
  'service-fee-text': 'Eine Servicegebühr kann erhoben werden, wenn Ihr zurückgegebenes Produkt Anzeichen von versehentlichem Schaden oder Missbrauch aufweist. Sie werden per E-Mail kontaktiert, wenn dies zutrifft.',
  'product-is-defective': 'Produkt ist defekt',
  'repair-status-list': [
    {
      'status': 'RMA-Anfrage erhalten',
      'desc': '<p>Ihre RMA-Anfrage wird derzeit bearbeitet.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>'
    },
    {
      status: 'RMA genehmigt',
      desc: `<p>Bitte senden Sie Ihr Produkt an uns zurück. </p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>
              <span style="font-weight: 500;">Rückgabeanleitung anzeigen</span>

              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Die Anweisungen zur Rücksendung finden Sie in der E-Mail (Betreff: Ihre Creative Labs-Rücksendeanforderung wurde genehmigt).
                  Sie können das Rücksendeetikett über den folgenden Link erstellen und die aufgeführten Informationen eingeben:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Bestellnummer:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Rücksendecode:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Beachten Sie, dass das Versandetikett nach der Verwendung nicht mehr verwendet werden kann.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Die Anweisungen zur Rücksendung finden Sie in der E-Mail (Betreff: Ihre Creative Labs-Rücksendeanforderung wurde genehmigt).
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Ihr Versandetikett muss innerhalb von 90 Tagen heruntergeladen werden.
                    Sobald das Etikett zum ersten Mal aufgerufen wird, muss es innerhalb von 5 Tagen heruntergeladen oder gedruckt werden.
                    Danach ist es nicht mehr zugänglich.<br><a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Versandetikett</a></p>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Beachten Sie, dass das Versandetikett nach der Verwendung nicht mehr verwendet werden kann.
                  </p>
                </div>
            </div>`
    },
    {
      status: 'Produkt erhalten',
      desc: '<p>Wir überprüfen Ihr zurückgegebenes Produkt.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>',
    },
    {
      status: 'Ersatz wird vorbereitet',
      desc: '<p>Wir prüfen den lagerbestand Ihres Ersatzgeräts.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>',
    },
    {
      status: 'Versand wird vorbereitet',
      desc: '<p>WirWir bereiten Ihr Ersatzgerät für den Versand vor.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>',
    },
    {
      status: 'Ersatz versendet',
      desc: '<p>Ihr Ersatzgerät wurde versendet.  <br /> </p>',
    }
  ],
  'refund-status-list': [
    {
      'status': 'RMA-Anfrage erhalten',
      'desc': '<p>Ihre RMA-Anfrage wird derzeit bearbeitet.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>'
    },
    {
      status: 'RMA genehmigt',
      desc: `<p>Bitte senden Sie Ihr Produkt an uns zurück. </p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>
              <span style="font-weight: 500;">Rückgabeanleitung anzeigen</span>
              <div class="return-instruction">
                <div id="display_eu" style="display:{display_eu}">
                  Anweisungen zur Rücksendung finden Sie in der E-Mail (Betreff: Ihre Rücksendeanforderung von Creative Labs wurde genehmigt).
                  Bitte erstellen Sie Ihr Rücksendeetikett über den folgenden Link und geben Sie folgende Informationen ein:
                  <p style="margin:10px auto">
                    URL: <a href="{courierLabelLink}" target="_blank">{courierLabelLink}</a> <br>
                    Bestellnummer:  <span style='font-weight:500'>{orderNumber}</span> <br>
                    Rücksendecode:   <span style='font-weight:500'>{b2cTrackingNumber}</span> <br>
                  </p>
                  <p>
                    Beachten Sie, dass das Versandetikett nach der Verwendung nicht mehr verwendet werden kann.
                  </p>
                </div>

                <div id="display_others" style="display:{display_others}">
                  Anweisungen zur Rücksendung finden Sie in der E-Mail (Betreff: Ihre Rücksendeanforderung von Creative Labs wurde genehmigt).
                  <p id="display_shippingLabel1" style="margin:10px auto;{display_shippingLabel}">
                    Ihr Versandetikett muss innerhalb von 90 Tagen heruntergeladen werden.
                    Sobald das Etikett zum ersten Mal aufgerufen wird, muss es innerhalb von 5 Tagen heruntergeladen oder gedruckt werden.
                    Danach ist es nicht mehr zugänglich.<br><a href="{courierLabelLink}" target="_blank" style="text-decoration:underline">Versandetikett</a></p>
                  </p>
                  <p id="display_shippingLabel2" style="margin:10px auto;{display_shippingLabel}">
                    Beachten Sie, dass das Versandetikett nach der Verwendung nicht mehr verwendet werden kann.
                  </p>
                </div>
            </div>`
    },
    {
      status: "Produkt erhalten",
      desc: "<p>Wir überprüfen Ihr zurückgegebenes Produkt.</p><p><i>(Dauert normalerweise 1 - 2 Werktage)</i></p>",
    },
    {
      status: "Rückerstattung in Bearbeitung",
      desc: "<p>Ihr Produkt wurde überprüft und wir bearbeiten Ihre Rückerstattung<span style='{showAmount}'> von <strong>{RefundAmtActual}</strong> USD</span>.</p><p><i>(Dauert normalerweise 1 - 3 Werktage)</i></p>",
    },
    {
      status: "Rückerstattung abgeschlossen",
      desc: "<p>Wir haben die Rückerstattung auf Ihrem ursprüngliche Zahlungweg zurückerstattet. Es kann bis zu 30 Tage dauern, bis Ihre Bank die Anfrage bearbeitet hat. Bitte kontaktieren Sie Ihre Bank für weitere Anfragen.</p><p><i>(May take up to 30 days for your bank to process the receiving of the refund)</i></p>",
    }
  ],
  'what-are-reason': 'Was ist der Grund für Ihrer Rückgabe?',
  'which-part-defective': 'Welcher Teil Ihres Produkts ist defekt?',
  'please-select-one': 'Bitte wählen Sie eins aus.',
  'cosmetic-damages': 'Gibt es physische / optische Schäden am Produkt?',
  'attach-photo': 'Fügen Sie ein Foto der Schäden bei:',
  'comments': 'Bemerkungen',
  'enter-comments': 'Bitte geben Sie eine detaillierte Beschreibung Ihrer Anfrage ein.',
  'rma-exists': 'Für dieses Produkt wurde eine RMA-Anfrage eingereicht.',
  'rma-created': 'Für dieses Produkt ist bereits eine RMA-Anforderung vorhanden, die nicht erneut erstellt werden kann.',
  'rma-cancelled': 'Ihre RMA-Anfrage wurde storniert. Wenn Sie Fragen zu Ihrer Stornierung Ihrer RMA-Anfrage haben, wenden Sie sich bitte an uns.',
  'selected-maximum': 'Sie haben die maximal zulässige Menge ausgewählt.',

  'shipping-information': 'Ihre Lieferangaben',
  'shipping-address': 'Lieferadresse',
  'select-shipping-address': 'Lieferadresse auswählen',
  'replace-sent-address': 'Ihr Ersatz wird an die folgende Lieferadresse gesendet.  ',
  'product-purchased-from': 'Produkt gekauft von',
  'creative-store': 'Creative Store',
  'all-other-retailers': 'Alle anderen Händler',
 'product-not-received': 'Nicht erhalten',
  'product-cancelled': 'Abgebrochen',
  'rma-closed': 'Schließen',
  'select-mode-of-contact': 'Bitte wählen Sie Ihre Kontaktart.',
  'email-us': 'E-Mail an uns',
  'your-order': 'Ihre Bestellung',
  'refund-amount': 'Rückerstattungsbetrag',
  'shipping-charge': 'Versandkosten',
  'store-credit': 'Store-Guthaben',
  'tax': 'Steuern',
  'deliver-unable-info':'Wir können nicht an Postfächer, Packstationen, Hotels, Motels und die folgenden Übersee-Gebiete liefern. <a href="/help/lieferung#what-are-the-overseas-territories-that-you-don-39-t-deliver-to" target="_blank">Mehr erfahren</a>.',
  'creative-in-warranty': '',
  'extended-warranty': '',
  'maintenance-msg': `Hinweis: Unsere Webseiten werden einer planmäßigen Wartung unterzogen, um Ihnen einen besseren Service zu bieten. Die Wartung ist für Sonntag, den 09. Oktober 2022 von 9:00 bis 15:00 Uhr (GMT +8:00) geplant. Während dieser Zeit sind unsere Webseiten nicht erreichbar.
                      <br><br>
                      Wir entschuldigen uns für die entstandenen Unannehmlichkeiten. Vielen Dank für Ihre Geduld.`,
  'shipping-country-notice-de': 'Diese Website versendet nur nach Deutschland und schließt alle Überseegebiete wie Büsingen am Hochrhein und Helgoland aus. Wir können auch nicht an Postfächer, Packstationen, Hotels, Motels und mehr liefern. <a href="/help/lieferung#wohin-liefern-sie" target="_blank">Mehr erfahren</a>.'
}